/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { cloneElement } from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
export var EuiScreenReaderOnly = ({
  children,
  showOnFocus
}) => {
  const classes = classNames({
    euiScreenReaderOnly: !showOnFocus,
    'euiScreenReaderOnly--showOnFocus': showOnFocus
  }, children.props.className);
  const props = { ...children.props,
    className: classes
  };
  return cloneElement(children, props);
};
EuiScreenReaderOnly.propTypes = {
  children: PropTypes.element.isRequired,

  /**
     * For keyboard navigation, force content to display visually upon focus.
     */
  showOnFocus: PropTypes.bool
};

try {
  // @ts-ignore
  EuiScreenReaderOnly.displayName = "EuiScreenReaderOnly"; // @ts-ignore

  EuiScreenReaderOnly.__docgenInfo = {
    "description": "",
    "displayName": "EuiScreenReaderOnly",
    "props": {
      "showOnFocus": {
        "defaultValue": null,
        "description": "For keyboard navigation, force content to display visually upon focus.",
        "name": "showOnFocus",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src/components/accessibility/screen_reader.tsx#EuiScreenReaderOnly"] = {
      docgenInfo: EuiScreenReaderOnly.__docgenInfo,
      name: "EuiScreenReaderOnly",
      path: "src/components/accessibility/screen_reader.tsx#EuiScreenReaderOnly"
    };
} catch (__react_docgen_typescript_loader_error) {}